import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=07776516"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"
import style0 from "./CategoryForm.vue?vue&type=style&index=0&id=07776516&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07776516')) {
      api.createRecord('07776516', component.options)
    } else {
      api.reload('07776516', component.options)
    }
    module.hot.accept("./CategoryForm.vue?vue&type=template&id=07776516", function () {
      api.rerender('07776516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AccountSetup/CategoryForm.vue"
export default component.exports